export default "__VITE_ASSET__rm6GYXwB__"